import { allSoundSources } from "../sounds/catalog";
import startTask from "../AudioFiles/startTaskCut.mp3";
import doneTask from "../AudioFiles/DoneTask.mp3";
import beep from "../AudioFiles/beepWaring.mp3";
import negative from "../AudioFiles/interfaceTaskWarningNegative.mp3";
import early from "../AudioFiles/taskLessTimeAlert.mp3";
import due from "../AudioFiles/FailedTask.mp3";
import focus from "../AudioFiles/FocusRetainer.mp3";
import bell from "../AudioFiles/small-3-tibet-bowl-sound_cropped.mp3";

const sources = [...new Set([startTask, doneTask, beep, negative, early, due, focus, bell, ...allSoundSources])];
const sounds = new Map();
const buffers = new Map();
const playing = new Set();
let context;

const getContext = () => {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return null;
  if (!context || context.state === "closed") {
    context = new AudioContext();
    buffers.clear();
  }
  return context;
};

const loadBuffer = (source, audioContext) => {
  if (!buffers.has(source)) {
    const loading = fetch(source)
      .then((response) => {
        if (!response.ok) throw new Error(`Audio request failed: ${response.status}`);
        return response.arrayBuffer();
      })
      .then((data) => audioContext.decodeAudioData(data))
      .catch((error) => {
        buffers.delete(source);
        throw error;
      });
    buffers.set(source, loading);
  }
  return buffers.get(source);
};

// Call directly from a click: resume before any fetch/await loses the gesture.
export const unlockAudio = () => {
  try {
    const audioContext = getContext();
    if (!audioContext) return Promise.resolve();
    const ready = audioContext.state === "running" ? Promise.resolve() : audioContext.resume();
    // Load every alert ahead of its deadline, without playing it.
    sources.forEach((source) => {
      loadBuffer(source, audioContext).catch((error) => console.warn("Sound could not load", source, error));
    });
    return ready.catch((error) => console.warn("Sound could not be enabled", error));
  } catch (error) {
    console.warn("Sound could not be enabled", error);
    return Promise.resolve();
  }
};

export const playSound = async (source) => {
  let bufferPlayback = false;
  try {
    const audioContext = getContext();
    if (audioContext) {
      if (playing.has(source)) return;
      playing.add(source);
      bufferPlayback = true;
      // resume() is invoked synchronously when this call comes from Play.
      await unlockAudio();
      if (audioContext.state !== "running") throw new Error("Audio context is not running");
      const buffer = await loadBuffer(source, audioContext);
      const node = audioContext.createBufferSource();
      node.buffer = buffer;
      node.connect(audioContext.destination);
      node.onended = () => {
        playing.delete(source);
        node.disconnect();
      };
      node.start();
      return;
    }
    // Fallback for browsers without Web Audio.
    let audio = sounds.get(source);
    if (!audio) {
      audio = new Audio(source);
      audio.preload = "auto";
      sounds.set(source, audio);
    }
    if (!audio.paused) return;
    audio.currentTime = 0;
    await audio.play();
  } catch (error) {
    if (bufferPlayback) playing.delete(source);
    console.warn("Sound alert could not play", source, error);
  }
};
